import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InspectionService } from '../inspection.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { DeepCopyPipe } from '@quorum/common-pipes';
import { InspectionCauseCorrectionDialog } from '../inspection-cause-correction-dialog/inspection-cause-correction-dialog.component';
import { MediaStateService } from '@quorum/sha-media';
import { VehicleInspectionWearPattern } from '@quorum/models/xs-resource';

@Component({
  selector: 'vip-inspection-category',
  templateUrl: './inspection-category.component.html',
  styleUrls: ['./inspection-category.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('100ms', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('100ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class InspectionCategoryComponent implements OnInit {
  @Input() category: any;
  @Input() tab: any;
  @Input() mediaParams: any;
  @Input() displaySaviIconFlags: { gmOem: boolean; vehicleDiagnosticsEnabled: boolean };
  @Input() wearPatterns: readonly VehicleInspectionWearPattern[] = [];
  @Input() embedded = false;
  @Output() updatedInspection: EventEmitter<any> = new EventEmitter<any>();
  selectedFile: any;
  taskIdToLinkMedia: number;
  constructor(
    public inspectionService: InspectionService,
    public dialog: MatDialog,
    public mediaStateService: MediaStateService
  ) {}

  ngOnInit() {
    if (this.category && this.category.tasks) {
      this.category.tasks.forEach((task: any) => {
        task.passFailOnly = this.isPassFailOnly(task);
        task.yesNoOnly = this.isYesNoOnly(task);
      });
    }
  }

  displayComments(task: any) {
    const dialogTasks = new DeepCopyPipe().transform(task);
    const dialogRef = this.dialog.open(InspectionCauseCorrectionDialog, {
      width: '80%',
      maxWidth: '580px',
      disableClose: true,
      data: { task: dialogTasks },
    });

    dialogRef.afterClosed().subscribe((taskWithComments) => {
      if (taskWithComments && taskWithComments !== 'cancelled') {
        task.note = taskWithComments.note;
        task.cause = taskWithComments.cause;
        task.correction = taskWithComments.correction;
        task.saveComments = taskWithComments.saveComments;
        this.inspectionChanged();
      }
    });
  }

  highlightText(event: any) {
    event.target.select();
  }

  numbersOnly(event: any) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }

  taskButtonGroupChange(value: any, task: any) {
    if (task.displayVoltage) {
      this.inspectionService.omitDisplayVoltage(this.inspectionService.inspection, task);
    } else if (task.displayOilLife) {
      this.inspectionService.omitOilLife(task);
    } else if (task.displayTireTread) {
      this.inspectionService.toggleTaskOmit(task);
    } else {
      switch (value) {
        case 'greyBox':
          this.inspectionService.onTaskActionChange('grey', task);
          break;
        case 'yellowBox':
          this.inspectionService.onTaskActionChange('yellow', task);
          break;
        case 'redBox':
          this.inspectionService.onTaskActionChange('red', task);
          break;
        case 'greenBox':
          this.inspectionService.onTaskActionChange('green', task);
          break;
      }
    }
  }

  toggleTask(value: any, task: any) {
    var self = this;
    switch (value) {
      case 'greyBox':
        task.greyBox = !task.greyBox;
        self.inspectionService.onTaskActionChange('grey', task);
        break;
      case 'yellowBox':
        task.yellowBox = !task.yellowBox;
        break;
      case 'redBox':
        task.redBox = !task.redBox;
        break;
      case 'greenBox':
        task.greenBox = !task.greenBox;
        break;
    }
  }

  categoryOmitUnselected(category: any) {
    var self = this;
    category.tasks.forEach((task: any) => {
      if (task.greenBox === false && task.yellowBox === false && task.redBox === false && task.greyBox === false) {
        task.greyBox === true;
        self.inspectionService.onTaskActionChange('grey', task);
      }
    });
  }

  inspectionChanged() {
    this.updatedInspection.emit(this.inspectionService.inspection);
  }

  isPassFailOnly(task: any): boolean {
    const passFailInspectionIds = [
      'HYU_WINDSHIELD',
      'HYU_WIPER_BLADES_WASHER_SPRAY',
      'HYU_HORN',
      'HYU_INTERIOR_LIGHTS',
      'HYU_EXTERIOR_LIGHTS',
    ];
    return passFailInspectionIds.includes(task.inspectionId);
  }

  isYesNoOnly(task: any): boolean {
    const passFailInspectionIds = [
      'HYU_CORRECT_TIRES_CHECK',
      'HYU_FLOOR_LINERS_CHECK',
      'HYU_CUSTOMER_SETTINGS_RETURNED',
      'HYU_RECALLS_CHECKED',
      'HYU_RESET_SERVICE_REMINDERS',
      'HYU_CUSTOMER_DECLINED_MAINTENANCE',
      'HYU_FLOOR_LINERS_INSTALLED',
      'HYU_FUEL_INJECTOR_CLEANER',
      'HYU_SEASONAL_TIRES_CHANGED',
      'HYU_SEALANT_EXPIRATION_CHECK',
      'HYU_V2L_INSTALLED',
      'HYU_LOW_CONDUCTIVITY_COOLANT_REPLACEMENT',
    ];
    return passFailInspectionIds.includes(task.inspectionId);
  }
}
